export default __webpack_public_path__ + "static/media/van-light.7664f95c.svg";